import React, { ReactElement } from 'react';
import { Modal, Button } from '@amzn/awsui-components-react';
import { useTranslation } from 'react-i18next';

export type PromptProps = {
  title?: string;
  type: PromptTypes;
  visible: boolean;
  body: string | ReactElement | null;
  onConfirm?: () => void;
  onCancel?: () => void;
};

export enum PromptTypes {
  INFO,
  CONFIRM,
  SUBMIT,
}

/**
 * Uses Modal to display an alert box can be "yes/no" confirm box or "ok" info box
 * @param {string} title header of the modal
 * @param {PromptTypes} type info modal or confirm modal
 * @param {boolean} visible is modal visible
 * @param {string | ReactElement} body body of the modal pass string, or a react element
 * @param {function} onConfirm called on confirm button click
 * @param {function} onCancel called when cancel button/ close button or background is clicked
 */
export default function Prompt(props: PromptProps): ReactElement {
  const { title, type, onConfirm, onCancel, visible, body } = props;
  const { t } = useTranslation();
  return (
    <Modal
      onDismiss={onCancel}
      visible={visible}
      header={title}
      footer={
        <>
          {type === PromptTypes.CONFIRM && (
            <span className="awsui-util-f-r">
              <Button variant="link" data-test-id="button-prompt-cancel" onClick={onCancel}>
                {t('common.no')}
              </Button>
              <Button variant="primary" data-test-id="button-prompt-confirm" onClick={onConfirm}>
                {t('common.yes')}
              </Button>
            </span>
          )}
          {type === PromptTypes.INFO && (
            <span className="awsui-util-f-r">
              <Button variant="link" onClick={onConfirm}>
                {t('common.ok')}
              </Button>
            </span>
          )}
          {type === PromptTypes.SUBMIT && (
            <span className="awsui-util-f-r">
              <Button variant="link" onClick={onCancel}>
                {t('common.cancel')}
              </Button>
              <Button variant="primary" onClick={onConfirm}>
                {t('common.submit')}
              </Button>
            </span>
          )}
        </>
      }>
      {body}
    </Modal>
  );
}
